module.exports = __webpack_public_path__ + "media/images/okra-offers/twitter-901cf202797ce99ca50e201024888ffd.svg";